/**
 * Runtime environment. Empty API_URL means "same origin", which in dev hits the Vite proxy.
 * Native builds must set VITE_API_URL to a reachable host (see apps/client/.env.example).
 */
export const API_URL: string = (import.meta.env.VITE_API_URL ?? "").replace(/\/$/, "");
export const IS_DEV: boolean = import.meta.env.DEV;
/** Build-time platform target for wrappers that serve the same web bundle (e.g. "steam"). */
export const PLATFORM_TARGET: string = import.meta.env.VITE_PLATFORM ?? "";

/** @public Crash reporting (platform/crash/sentry.ts, parked). Empty means "not installed". */
export const SENTRY_DSN: string = import.meta.env.VITE_SENTRY_DSN ?? "";
